import React from 'react';
import './SaveTemplateDialog.css';

const SaveTemplateDialog = ({ onClose, onSave }) => {
    return (
        <div className="dialog-overlay">
            <div className="dialog-container">
                <button className="dialog-close" onClick={onClose}>×</button>
                <h2 className="dialog-title">Name Your Template</h2>
                <p className="dialog-description">
                    You can select this template in the dropdown list with this name.
                </p>
                <input 
                    type="text" 
                    className="dialog-input" 
                    placeholder=""
                />
                <div className="dialog-actions">
                    <button className="dialog-cancel" onClick={onClose}>Cancel</button>
                    <button className="dialog-save" onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default SaveTemplateDialog;
